<template>
  <div class="title-banner-wrapper">
    <div class="overlay" />
    <div class="title-banner">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="scss" scoped>
@use "~common_styles/breakpoints" as breakpoints;

.title-banner-wrapper {
  position: relative;
  z-index: 0;
  background-position-x: center;

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: rgba(255, 255, 255, 0.6);
  }

  .title-banner {
    min-height: 165px;
    text-align: center;
    color: #333;

    @include breakpoints.screen-mobile-only {
      padding: 10px;
    }
  }
}

::v-deep(.foreground-content-wrapper) {
  @include breakpoints.screen-md-up {
    padding: 0 150px;
  }
}

::v-deep(.foreground-content) {
  padding: 50px;
  margin-bottom: 40px;
  z-index: 1;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 6px;

  h1 {
    max-width: 800px;
    margin: auto auto 38px auto;
    color: #333;
    font-size: 2em;
    font-weight: bold;
    margin-top: 0;
  }
}
</style>
